<template>
    <el-icon class="is-loading">
        <Loading />
    </el-icon>
</template>
